// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FormatPainterOutlinedSvg from "@fishx/icons-svg/es/asn/FormatPainterOutlined";
import FishxIcon from '../components/FishxIcon';

var FormatPainterOutlined = function FormatPainterOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FormatPainterOutlinedSvg
  }));
};

FormatPainterOutlined.displayName = 'FormatPainterOutlined';
export default React.forwardRef(FormatPainterOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FormatPainterOutlined.js
// module id = 2821
// module chunks = 0